import './Input.scss';
import Component from './Input.js';
export default Component;
